import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Trust } from "../components/home/Trust";
import { useLang } from "../i18n/LanguageContext";
import { CASE_STUDIES } from "../data/caseStudies";

export default function CaseStudies() {
  const { t, lang } = useLang();
  return (
    <main data-testid="case-studies-page">
      <PageHero kicker={t.nav.cases} title={t.pages.cases.title} sub={t.pages.cases.sub} testId="cases-hero" />
      <section className="bg-white py-8 md:py-12">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {CASE_STUDIES.map((cs, i) => (
            <motion.div
              key={cs.slug}
              data-testid={`case-card-${cs.slug}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <Link to={`/case-studies/${cs.slug}`} className="group block overflow-hidden rounded-2xl border border-black/[0.07] bg-white hover:shadow-xl hover:shadow-sinovar-navy/5 transition-shadow">
                <div className="overflow-hidden aspect-[16/10]">
                  <img src={cs.image} alt={cs.brand} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-7">
                  <div className="text-xs font-bold tracking-[0.16em] text-sinovar-navy/50">{cs.brand}</div>
                  <h3 className="mt-3 font-display text-xl md:text-2xl font-bold tracking-tight text-sinovar-navy leading-snug">{cs.title[lang]}</h3>
                  <p className="mt-3 text-[15px] text-sinovar-navy/60 leading-relaxed">{cs.excerpt[lang]}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-sinovar-blue">
                    {t.caseStudy.cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
      <Trust />
    </main>
  );
}
